module.exports = __webpack_public_path__ + "static/media/sp.82226259.png";